import './AppSidebar.css'
import { Link } from 'react-router-dom'
import { Logo } from '../Logo/Logo'

export interface AppSidebarProps {
  appLabel: string
  children: React.ReactNode
  acountSection?: React.ReactNode
  homeLink?: string
  languageSelector?: React.ReactNode
}

export function AppSidebar({
  appLabel,
  children,
  acountSection,
  homeLink = '/',
  languageSelector
}: AppSidebarProps) {
  return (
    <aside className="app-sidebar" aria-label="Sidebar">
      <div className="app-sidebar-content">
        <Link to={homeLink}>
          <header className="app-sidebar-header">
            <div>
              <span className="app-sidebar-logo">
                Artem<span className="app-sidebar-logo-accent">CBAM™</span>
              </span>
            </div>
            <div>
              <span className="app-sidebar-label">{appLabel}</span>
            </div>
          </header>
        </Link>
        <nav className="app-sidebar-nav">{children}</nav>
        {acountSection && (
          <section className="app-sidebar-account-section">{acountSection}</section>
        )}
        <footer className="app-sidebar-footer">
          <span>
            <Logo className="app-sidebar-footer-logo" />
            <small className="app-sidebar-footer-content">© 2025 Artem Technologie AG</small>
          </span>
          {languageSelector}
        </footer>
      </div>
    </aside>
  )
}
